import { useContext } from 'react';
import { UnicoContext, UnicoContextValue } from './unico-context';

export const useUnicoContext = (): UnicoContextValue => {
  const context = useContext(UnicoContext);
  if (!context) {
    throw new Error('useUnicoContext must be used within UnicoProvider');
  }
  return context;
};
